const VUE_APP_API_ZKAPI_URL = document.querySelector("body").getAttribute("api_zkapi_url");

export default VUE_APP_API_ZKAPI_URL
